/**
 * Samedi Social Media Section JavaScript
 * Extracted from samedi-home-social-media.liquid
 * Handles embed loading and carousel navigation
 */

(function() {
  'use strict';

  /**
   * Load Instagram and TikTok embed scripts
   */
  function loadEmbedScripts() {
    const embedsContainer = document.querySelector('.social-embeds-container');
    if (!embedsContainer) return;

    // Load Instagram embed script
    if (document.querySelector('.embed-wrapper blockquote[class*="instagram"]')) {
      if (!window.instgrm) {
        const script = document.createElement('script');
        script.async = true;
        script.src = '//www.instagram.com/embed.js';
        script.onload = function() {
        };
        script.onerror = function() {
        };
        document.body.appendChild(script);
      } else {
        window.instgrm.Embeds.process();
      }
    }

    // Load TikTok embed script
    if (document.querySelector('.embed-wrapper blockquote[class*="tiktok"]')) {
      if (!window.TikTok) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.tiktok.com/embed.js';
        script.onload = function() {
        };
        script.onerror = function() {
        };
        document.body.appendChild(script);
      }
    }
  }

  /**
   * Initialize carousel navigation
   */
  function initCarousel() {
    const carousel = document.querySelector('.embeds-carousel');
    const prevBtn = document.querySelector('.carousel-nav-prev');
    const nextBtn = document.querySelector('.carousel-nav-next');

    if (!carousel || !prevBtn || !nextBtn) return;

    /**
     * Get number of visible slides based on viewport width
     */
    const getVisibleSlides = () => {
      const width = window.innerWidth;
      if (width > 1024) return 3;
      if (width > 768) return 2;
      return 1;
    };

    /**
     * Scroll carousel in specified direction
     */
    const scrollCarousel = (direction) => {
      const slideEl = carousel.querySelector('.carousel-slide');
      if (!slideEl) return;

      const slideWidth = slideEl.offsetWidth;
      const gap = 20;
      const visibleSlides = getVisibleSlides();
      const scrollAmount = (slideWidth + gap) * visibleSlides;

      if (direction === 'next') {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
    };

    /**
     * Update button visibility based on scroll position
     */
    const updateButtons = () => {
      const isAtStart = carousel.scrollLeft <= 0;
      const isAtEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1;

      prevBtn.style.opacity = isAtStart ? '0.3' : '1';
      prevBtn.style.pointerEvents = isAtStart ? 'none' : 'auto';

      nextBtn.style.opacity = isAtEnd ? '0.3' : '1';
      nextBtn.style.pointerEvents = isAtEnd ? 'none' : 'auto';
    };

    // Event listeners
    prevBtn.addEventListener('click', () => scrollCarousel('prev'));
    nextBtn.addEventListener('click', () => scrollCarousel('next'));

    // Throttle scroll event for performance
    let scrollTimeout;
    carousel.addEventListener('scroll', () => {
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout);
      }
      scrollTimeout = window.requestAnimationFrame(updateButtons);
    }, { passive: true });

    window.addEventListener('resize', updateButtons);

    // Initial button state
    updateButtons();
  }

  /**
   * Remove will-change after animations complete
   */
  function cleanupAnimations() {
    setTimeout(() => {
      const animatedElements = document.querySelectorAll('.social-banner-header, .social-connect-bar');
      animatedElements.forEach(el => {
        el.classList.add('animation-complete');
      });
    }, 1500); // After all animations complete
  }

  /**
   * Update social section for audience
   */
  function updateSocialSection(audience) {
    const wrapper = document.querySelector('.social-banner-wrapper');
    if (!wrapper) return;

    // Update background color
    if (audience === 'men') {
      wrapper.style.background = '#f8f8f8'; // Light gray for men
    } else {
      wrapper.style.background = '#faf9f7'; // Warm beige for women
    }

    // Update body class
    document.body.classList.remove('audience-women', 'audience-men');
    document.body.classList.add('audience-' + audience);
  }

  /**
   * Initialize
   */
  function init() {
    loadEmbedScripts();
    initCarousel();
    cleanupAnimations();

    // Set initial audience
    const savedAudience = window.SamediUtils.getCurrentAudience() || 'women';
    updateSocialSection(savedAudience);

    // Listen for audience changes from theme-utilities.js
    window.SamediUtils.onAudienceChange(function(newAudience) {
      updateSocialSection(newAudience);
    });

    // Listen for storage changes (cross-tab sync)
    window.addEventListener('storage', function(e) {
      if (e.key === 'audience') {
        updateSocialSection(e.newValue);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
